module.exports = __webpack_public_path__ + "img/1.c25e0d0f.png";